import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Grid, Checkbox, FormControlLabel, Typography, CircularProgress
} from '@material-ui/core'
import { BID_SCOPES } from '../constants/bidScopes'

const ScopeSelectionModal = ({ open, project, url, onComplete, onSkip, excludeScopes }) => {
  const excluded = excludeScopes || []
  const suggested = (project && project.templateSuggestedScopes) || []
  const [selectedScopes, setSelectedScopes] = React.useState([])
  const [generating, setGenerating] = React.useState(false)
  const [error, setError] = React.useState('')

  React.useEffect(() => {
    if (open && project) {
      setSelectedScopes(suggested.filter(s => BID_SCOPES.includes(s)))
      setError('')
    }
  }, [open, project])

  const handleToggle = (scope) => {
    setSelectedScopes(prev =>
      prev.includes(scope) ? prev.filter(s => s !== scope) : [...prev, scope]
    )
  }

  const handleGenerate = () => {
    if (selectedScopes.length === 0) return
    setGenerating(true)
    setError('')

    axios.post(`${url}/api/bid-estimation/projects/${project._id}/modules/generate`, {
      scopes: selectedScopes
    }).then(() => {
      setGenerating(false)
      onComplete(project._id)
    }).catch(err => {
      setGenerating(false)
      setError(err.response?.data?.error || 'Failed to generate modules')
    })
  }

  return (
    <Dialog open={open} onClose={() => onSkip(project?._id)} maxWidth="sm" fullWidth>
      <DialogTitle>Select Scopes for "{project?.name || ''}"</DialogTitle>
      <DialogContent>
        <Grid container spacing={1}>
          {BID_SCOPES.filter(s => !excluded.includes(s)).map(scope => (
            <Grid item xs={4} key={scope}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedScopes.includes(scope)}
                    onChange={() => handleToggle(scope)}
                    color="primary"
                    size="small"
                  />
                }
                label={<Typography variant="body2">{scope}</Typography>}
              />
            </Grid>
          ))}
        </Grid>
        {error && (
          <Typography color="error" variant="body2" style={{ marginTop: 8 }}>{error}</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onSkip(project?._id)} style={{ textTransform: 'none' }}>
          Skip for now
        </Button>
        <Button
          onClick={handleGenerate}
          variant="contained"
          color="primary"
          disabled={selectedScopes.length === 0 || generating}
          style={{ textTransform: 'none' }}
        >
          {generating ? <CircularProgress size={20} /> : 'Generate Modules'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = (state) => ({
  url: state.url
})

export default connect(mapStateToProps)(ScopeSelectionModal)
